<template>
	<div>
		<b-form>
			<b-container>
				<b-row>
					<b-col>
						<b-form-group label="Course Title">
							<b-input placeholder="ex. Intro to History" v-model="active_syllabus.course_title" aria-label="course title"></b-input>
						</b-form-group>
						<b-form-group label="Course Number">
							<b-input placeholder="ex. HIS 301" v-model="active_syllabus.course_number" aria-label="course number"></b-input>
						</b-form-group>
						<b-form-group label="Course Instructor">
							<b-input placeholder="ex. Dr. J. Doe" v-model="active_syllabus.course_instructor" aria-label="course instructor"></b-input>
						</b-form-group>
						<b-form-group label="Course TA's (optional)">
							<b-input placeholder="" v-model="active_syllabus.course_tas" aria-label="course TA's (optional)"></b-input>
						</b-form-group>
						<b-form-group label="Location">
							<b-input placeholder="ex. WEL 140" v-model="active_syllabus.course_location" aria-label="location"></b-input>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group label="Start Time">
							<b-input placeholder="ex. 1:00 PM" v-model="active_syllabus.start_time" aria-label="start time"></b-input>
						</b-form-group>
						<b-form-group label="Semester Start Date">
							<date-picker :config="datetime_config" v-model="active_syllabus.start_date" aria-label="semester start date"/>
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group label="End Time">
							<b-input placeholder="ex. 2:00 PM" v-model="active_syllabus.end_time" aria-label="end time"></b-input>
						</b-form-group>
						<b-form-group label="Last Class Day">
							<date-picker :config="datetime_config" v-model="active_syllabus.end_date" aria-label="last class day"/>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group label="Course Has Final">
							<b-check v-model="active_syllabus.has_final" aria-label="course has final"/>
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group label="Final Exam Date">
							<date-picker :disabled="!active_syllabus.has_final" :config="datetime_config" v-model="active_syllabus.final_date" aria-label="final exam date"/>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group label="Class Days">
							<b-form-checkbox-group
								v-model="checked_days"
								:options="class_day_text"
								aria-label="class days"
							/>
						</b-form-group>
						<div v-if="!hide_continue">
							<b-btn v-if="!update_button" @click="continue_btn" :disabled="!inputs_valid" variant="primary">Continue</b-btn>
							<b-btn block v-else @click="update_days" :disabled="!inputs_valid" variant="primary">Update Class Dates</b-btn>
						</div>
					</b-col>
				</b-row>
			</b-container>
		</b-form>
	</div>
</template>

<script>
export default {
	props: {
		active_syllabus : Object,
		update_button : Boolean,
		hide_continue : Boolean
	},
	data(){
		return {
			datetime_config: {
				format: 'MM/DD/YYYY'
			},
			class_day_text: ["M", "T", "W", "Th", "F"],
			_checked_days: [],
			updating_checked: false
		}
	},
	computed: {
		input_error(){
			if (this.active_syllabus.course_title == '')
				return "Course title can't be blank";
			if (this.active_syllabus.course_instructor == '')
				return "Course instructor can't be blank";
			if (this.active_syllabus.course_number == '')
				return "Course number can't be blank";
			if (this.active_syllabus.course_location == '')
				return "Course location can't be blank";
			if (this.active_syllabus.start_time == '')
				return "Course start time can't be blank";
			if (this.active_syllabus.end_time == '')
				return "Course end time can't be blank";
			if (this.active_syllabus.start_date == '')
				return "Course start date can't be blank";
			if (this.active_syllabus.end_date == '')
				return "Course end date can't be blank";
			if (this.checked_days.length == 0)
				return "Course must have at least one class day";
			return null
		},
		inputs_valid(){
			return this.input_error == null;
		},
		checked_days: {
			get(){
				let ret = []
				for(let i = 0; i < this.active_syllabus.class_days.length; ++i)
				{
					if (this.active_syllabus.class_days[i])
					{
						ret.push(this.class_day_text[i]);
					}
				}
				return ret;
			},
			set(value){
				for(let i = 0; i < this.class_day_text.length; ++i)
				{
					let curDay = this.class_day_text[i];
					let found = false;
					for(let ii = 0; ii < value.length; ++ii)
					{
						if (value[ii] == curDay)
						{
							found = true;
							break;
						}
					}

					if (found != this.active_syllabus.class_days[i])
					{
						this.$set(this.active_syllabus.class_days, i, found)
					}
				}
			}
		}
	},
	methods: {
		day_valid(day){
			day -= 1;
			return day >= 0 && day < this.active_syllabus.class_days.length && this.active_syllabus.class_days[day];
		},
		update_days(){
			let start = new Date(this.active_syllabus.start_date);
			let end = new Date(this.active_syllabus.end_date);
			let i = 0;
			for(let date = start; date <= end; date.setDate(date.getDate() + 1))
			{
				if (this.day_valid(date.getDay()))
				{
					if (i < this.active_syllabus.class_day_data.length)
					{
						this.active_syllabus.class_day_data[i].date = new Date(date);
					}
					else
					{
						this.active_syllabus.class_day_data.push(
							{
								date: new Date(date),
								data: {}
							}
						);
					}
					++i;
				}
			}
			this.active_syllabus.class_day_data.length = i;
		},
		continue_btn(){
			let err = this.input_error;
			if (err != null)
			{
				alert(`Error: ${err}`);
				return;
			}
			
			this.update_days();
			this.active_syllabus.initialized = true;
			this.active_syllabus.sections.push({
				type: "text",
				title: "Course Description",
				text: "Thanks for choosing our syllabus generator!  To add content, click \"Content\" on the left side and either modify one of the existing entries or add your own.\n\nTo change the type of content, click on the dropdown.  There are currently two types of content: <b>Text</b>, and <b>Course Schedule</b>.\n\n<b>Text</b> entries look like this one - they have a header, and a body.  If you leave the body blank, none will appear.\n\n<b>Course Schedule</b> entries take the data you enter into \"Day Plans\" and automatically fill it out in the document.\n\nTo create a new entry, simply click \"Add Content\".  It will create a new <b>Text</b> entry by default.  To change it into a <b>Course Schedule</b> entry, click the dropdown box above the content title and change it to <b>Course Schedule</b>.\n\nBy default, we have generated a Text entry and a Course Schedule entry.\n<h4>REMEMBER TO ADD HOLIDAY BREAKS TO YOUR DAY PLANS!</h4>"
			}, {
				type: "schedule",
				title: "Course Schedule",
				text: ""
			})
			window.localStorage.setItem(this.active_syllabus.file_name, JSON.stringify(this.active_syllabus));
			this.$router.push(`/${this.active_syllabus.file_name}`);
		}
	}
}
</script>

<style lang="scss" scoped>

</style>
